'use strict';
import classNames from 'classnames';
import noop from 'lodash/noop';
import * as T from 'prop-types';
import React from 'react';
import {FormField, INPUT_TYPES} from '../../../components/forms/FormField';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';


export function BaseMilestoneFormView(props) {
  const constraints = props.constraints || {};
  const internalModel = props.internalModel || {};
  const onChange = props.onChange || {};

  const handleChangeName = onChange.name || noop;
  const handleChangeDescription = onChange.description || noop;

  return (
    <form
      className={classNames("MilestoneForm", props.className)}
      onSubmit={props.onSave}
    >
      <input
        type="submit"
        hidden={true}
      />
      <FormField
        className={classNames("MilestoneForm__field", props.fieldClass)}
        type={INPUT_TYPES.text}
        label={props.nameLabel}
        value={internalModel.name}
        validateImmediately={props.validateImmediately}
        isEditing={props.isEditing}
        isSaving={props.isSaving}
        constraints={constraints.name}
        onChange={handleChangeName}
      />
      <FormField
        className={classNames("MilestoneForm__field", props.fieldClass)}
        type={INPUT_TYPES.text_long}
        label={props.descriptionLabel}
        value={internalModel.description}
        validateImmediately={props.validateImmediately}
        isEditing={props.isEditing}
        isSaving={props.isSaving}
        constraints={constraints.description}
        onChange={handleChangeDescription}
      />
    </form>
  );
}

BaseMilestoneFormView.propTypes = {
  className: T.string,
  /** @type {String} fieldClass The class applied to each field */
  fieldClass: T.string,

  // values
  model: T.object,
  internalModel: T.object,

  canEdit: T.object,
  constraints: T.object,

  // Events
  onChange: T.object,
  onSave: T.func,

  // Form State
  isEditing: T.bool,
  isSaving: T.bool,

  nameLabel: T.string,
  descriptionLabel: T.string,
};

BaseMilestoneFormView.defaultProps = {
  className: '',
  fieldClass: '',

  nameConstraints: {nullable: false},
  descriptionConstraints: {nullable: true},
};

export const MilestoneFormView = I18nComponent(BaseMilestoneFormView, [
  {code: 'milestones.create.name.label', prop: 'nameLabel'},
  {code: 'milestones.create.description.label', prop: 'descriptionLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/projects/components/MilestoneForm/MilestoneFormView.js